import {
  API_STATUS,
  DELETE_PDF,
  CLEAR_API_STATUS,
  PRE_PRO_PROJECTS,
  UPLOADED_TEMPLATE_AND_PARAMETERS,
  GET_TAGS,
  UPLOADED_BATCH_PDFS,
  GET_USER_LIST,
  IS_SIGNATURE_UPLOADED_STATUS,
  ASSIGN_USER_API_STATUS,
  VALIDATE_USER_STATUS,
  UPDATE_FILTER,
  GET_UPLOADED_PDF_TAGS,
  GET_COOR_DATA,
  GET_PROJECT_TYPE_LIST,
  GET_OUTPUT_FORMAT_LIST,
  GET_PROJECT_TYPE,
  GET_SHEETS_LIST,
  AUTO_REFRESH,
  SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE,
  OCR_REINITIATE_STATUS,
  RESET_PRO_DATA_FROM_PRE,
  GET_TAGS_USERS_PDFS,
  QC_PARAMETERS_DATA,
  QC_SAVE_MAPPING_STATUS,
  LIST_UPLOADED_FILES_RECORD,
  UPLOADING_IP_OP_FILE_PREVIEW,
  CLONE_API_STATUS,
  SET_BBOX_FROM_DRAW_FROM_PRE,
  HIGHLIGHT_BBOX_IN_PRE,
  GET_INVESTIGATOR_USER_LIST,
  // SAVED_BATCHES_DATA,
} from "./types";
import preProcessorService from "../../services/preProcessorService";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import { messages } from "../../constants/commonMessages";
const service = new preProcessorService();

export const getPreProProjects = (obj) => {
  return (dispatch) => {
    !obj?.autoRefresh &&
      dispatch({
        type: PRE_PRO_PROJECTS,
        payload: { ...initialState.apiStatus, loader: true },
      });
    service
      .getProjects(obj)
      .then((response) => {
        dispatch({
          type: PRE_PRO_PROJECTS,
          payload: {
            data: response.data?.data?.preprocessor_projects,
            loader: false,
          },
        });
        !obj?.autoRefresh &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState.apiStatus,
              loader: false,
              apiSuccess: true,
            },
          });
      })
      .catch((error) => {
        dispatch({
          type: PRE_PRO_PROJECTS,
          payload: { ...initialState.apiStatus, loader: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.payload,
            apiError: true,
            loading: false,
            message: errorMessage(error),
          },
        });
      });
  };
};
export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_API_STATUS,
      payload: {},
    });
  };
};

export const createNewProject = (projectName, drugType, next, projectType) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });

    service
      .createNewProject({ projectName, drugType, projectType })
      .then((json) => {
        localStorage.setItem(messages.PROJECT_ID, json?.data?.data?.project_id);
        localStorage.setItem(
          messages.PROJECT_NAME,
          json?.data?.data?.project_name
        );
        localStorage.setItem("projectType", projectType);
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: next,
            message: json?.data?.message,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            apiError: true,
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const validateUserClear = () => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: {},
    });
  };
};
export const uploadFilesToServer = (
  data,
  // isSupplementaryPdf,
  next
) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { message: "", loader: true, next: false },
    });

    service
      .uploadMultipleFilesToServer(
        data
        // , isSupplementaryPdf
      )
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: response.data.message,
            loader: false,
            next: next,
            setSuccess: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: error.response,
            setError: true,
            apiError: true,
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const deletePdf = (batchId) => {
  let token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch({
      type: DELETE_PDF,
      payload: {},
    });
    service.deletePdfHandle(batchId, token);
  };
};

// export const createBatch = (batchName, projectId) => {
//   return (dispatch) => {
//     dispatch({
//       type: API_STATUS,
//       payload: { ...initialState.apiStatus, loader: true },
//     });
//     service
//       .createBatch(batchName, projectId)
//       .then((response) => {
//         localStorage.setItem(messages.BATCH_ID, response?.data?.data?.batch_id);
//         localStorage.setItem(
//           messages.BATCH_NAME,
//           response?.data?.data?.batch_name
//         );

//         dispatch({
//           type: API_STATUS,
//           payload: {
//             ...initialState.apiStatus,
//             loader: false,
//             next: true,
//             message: response.data.message,
//             setSuccess: true,
//             apiSuccess: true,
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: API_STATUS,
//           payload: {
//             ...initialState.apiStatus,
//             message: errorMessage(error),
//             loader: false,
//             next: false,
//             setError: true,
//             apiError: true,
//           },
//         });
//       });
//   };
// };
export const getUserList = () => {
  return (dispatch) => {
    dispatch({
      type: GET_USER_LIST,
      payload: { data: [], loader: true, message: "" },
    });
    service
      .getUserList()
      .then((json) => {
        dispatch({
          type: GET_USER_LIST,
          payload: { data: json.data.data, loader: false, message: "" },
        });
      })

      .catch((error) => {
        dispatch({
          type: GET_USER_LIST,
          payload: { data: [], message: errorMessage(error), loader: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            data: [],
            message: errorMessage(error),
            loader: false,
            setError: true,
            apiError: true,
          },
        });
      });
  };
};

export const isSignatureUploaded = () => {
  return (dispatch) => {
    dispatch({
      type: IS_SIGNATURE_UPLOADED_STATUS,
    });
    service
      .isSignatureUploaded()
      .then((json) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: {
            isSignatureUploaded: json?.data?.is_signature_uploaded,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: { message: errorMessage(error), setError: true },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            setError: true,
            apiError: true,
          },
        });
      });
  };
};

export const clearIsSignatureUploadedStatus = () => {
  return (dispatch) => {
    dispatch({
      type: IS_SIGNATURE_UPLOADED_STATUS,
      payload: "",
    });
  };
};
export const uploadedTagClear = () => {
  return (dispatch) => {
    dispatch({
      type: UPLOADED_BATCH_PDFS,
      payload: [],
    });
  };
};
export const validateUserPermission = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: {
        ...initialState.apiStatus,
        message: "",
        loader: true,
        next: false,
      },
    });

    service
      .userPermission(data)
      .then((json) => {
        dispatch({
          type: ASSIGN_USER_API_STATUS,
          payload: { message: "", loader: true, next: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loading: false,
            next: true,
            message: json.data.message,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: ASSIGN_USER_API_STATUS,
          payload: { message: "", loader: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });
      });
  };
};
export const submitEsignBatch = (userName, userId, userRole, userPassword) => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: { message: "", loader: true },
    });
    service
      .esignHandle(userName, userId, userRole, userPassword)
      .then((json) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: { message: "", loader: false, next: true, setSuccess: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: {
            message: errorMessage(error),
            loader: false,
            setError: true,
          },
        });
      });
  };
};

export const getUploadedTemplateAndOpFormat = (projectId) => {
  return (dispatch) => {
    dispatch({
      type: UPLOADED_TEMPLATE_AND_PARAMETERS,
      payload: [],
    });
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .getUploadedTemplateAndOpFormat(projectId)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: UPLOADED_TEMPLATE_AND_PARAMETERS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            isError: true,
            apiError: true,
          },
        });
      });
  };
};

export const uploadTemplateAndOpFormat = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .uploadTemplateAndOpFormat(data)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: data.next,
            message: response.data.message,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            isError: true,
            apiError: true,
          },
        });
      });
  };
};

export const getTags = (projectId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .getTags(projectId)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_TAGS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            apiError: true,
          },
        });
      });
  };
};

export const uploadBatchPdfs = (
  selectedFiles,
  projectId,
  batchId,
  checked,
  next
) => {
  return (dispatch) => {
    // let redirectToDashboard = true;
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    dispatch({
      type: API_STATUS,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        next: true,
        messages: checked ? messages?.BATCH_OCR : messages?.BATCH_NON_OCR,
      },
    });
    service
      .uploadBatchPdfs(selectedFiles, projectId, batchId, checked, next)
      .then((response) => {
        dispatch({
          type: AUTO_REFRESH,
          payload: { isAutoRefresh: true },
        });
      })
      .catch((error) => {
        // redirectToDashboard = false;
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getTagsAndPdf = (projectId, batchId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .getTagsAndPdf(projectId, batchId)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState.apiStatus, loader: false },
        });
        dispatch({
          type: UPLOADED_BATCH_PDFS,
          payload: response?.data?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const updateType = (type) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILTER,
      payload: type,
    });
  };
};

export const getUploadedPdfsWithTags = (projectId) => {
  return (dispatch) => {
    dispatch({
      type: GET_UPLOADED_PDF_TAGS,
      payload: [],
    });
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });

    service
      .getUploadedPdfsWithTags(projectId)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState.apiStatus, loader: false },
        });
        dispatch({
          type: GET_UPLOADED_PDF_TAGS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: false,
            messages: errorMessage(error),
          },
        });
      });
  };
};

export const getCoorData = (projectId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    dispatch({
      type: GET_COOR_DATA,
      payload: [],
    });
    service
      .getCoorData(projectId)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState.apiStatus, loader: false },
        });

        dispatch({
          type: GET_COOR_DATA,
          payload: {
            ...response.data.data,
          },
        });

        dispatch({
          type: QC_PARAMETERS_DATA,
          payload: response.data?.data?.qc_mapping_details?.parametersData,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            apiError: true,
          },
        });
      });
  };
};

// common action for batch and template pdf uploads and bulk batch creation
export const getS3Files = (fileType, subFolder) => {
  return (dispatch) => {
    dispatch({
      type: GET_PROJECT_TYPE_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: true,
        data: [],
      },
    });
    service
      .getS3Files(fileType, subFolder)
      .then((json) => {
        dispatch({
          type: GET_PROJECT_TYPE_LIST,
          payload: {
            ...initialState.apiStatus,
            data: json.data.data,
            loader: false,
            message: "",
          },
        });
      })

      .catch((error) => {
        dispatch({
          type: GET_PROJECT_TYPE_LIST,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            apiError: true,
            data: [],
          },
        });
      });
  };
};

export const clearGetS3Files = () => {
  return (dispatch) => {
    dispatch({
      type: GET_PROJECT_TYPE_LIST,
      payload: { data: [], loader: false, message: "", next: true },
    });
  };
};

export const getOutputformat = (subFolder) => {
  return (dispatch) => {
    dispatch({
      type: GET_OUTPUT_FORMAT_LIST,
      payload: { data: [], loader: true, message: "" },
    });
    service
      .getOutputFormat(subFolder)
      .then((json) => {
        dispatch({
          type: GET_OUTPUT_FORMAT_LIST,
          payload: { data: json.data.data, loader: false, message: "" },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_OUTPUT_FORMAT_LIST,
          payload: { data: [], message: errorMessage(error), loader: false },
        });
      });
  };
};

// export const getQcTemplateFormat = (subFolder, fileType) => {
//   return (dispatch) => {
//     dispatch({
//       type: GET_QC_TEMPLATE_FORMAT,
//       payload: { data: [], loader: true, message: "" },
//     });
//     service
//       .getQCTemplateFormat(subFolder, fileType)
//       .then((json) => {
//         dispatch({
//           type: GET_QC_TEMPLATE_FORMAT,
//           payload: {
//             data: json.data.data,
//             // data: [
//             //   {
//             //     file_url:
//             //       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/templates/new_int/Output_review.xlsx",
//             //     file_name: "qc.xlsx",
//             //   },
//             //   {
//             //     file_url:
//             //       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/templates/new_int/Sample_Extraction_Template.xlsx",
//             //     file_name: "qc2.xlsx",
//             //   },
//             //   {
//             //     file_url:
//             //       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/templates/new_int/unit_converstion_template.xlsx",
//             //     file_name: "qc3.xlsx",
//             //   },
//             // ],
//             loader: false,
//             message: "",
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: GET_QC_TEMPLATE_FORMAT,
//           payload: { data: [], message: errorMessage(error), loader: false },
//         });
//       });
//   };
// };

export const getDrugType = () => {
  return (dispatch) => {
    dispatch({
      type: GET_PROJECT_TYPE,
      payload: { data: [], loader: true, message: "" },
    });
    service
      .getProjectFiles()
      .then((json) => {
        dispatch({
          type: GET_PROJECT_TYPE,
          payload: { data: json.data.data, loader: false, message: "" },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PROJECT_TYPE,
          payload: { data: [], message: errorMessage(error), loader: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            apiError: true,
          },
        });
      });
  };
};
export const mapData = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: API_STATUS,
        payload: { ...initialState.apiStatus, loader: true },
      });
    service
      .mapData(data)
      .then((response) => {
        !data.autosave === true &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState.apiStatus,
              message: response.data.message,
              loader: false,
              next: data?.next,
              apiSuccess: true,
            },
          });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            data: [],
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });
      });
  };
};

export const qcMapData = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: QC_SAVE_MAPPING_STATUS,
        payload: { ...initialState.apiStatus, loader: true },
      });
    service
      .qcMapData(data)
      .then((response) => {
        // !data.autosave === true &&
        dispatch({
          type: QC_SAVE_MAPPING_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: response.data.message,
            loader: false,
            next: data?.next,
            apiSuccess: true,
            autosave: data.autosave,
          },
        });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: QC_SAVE_MAPPING_STATUS,
          payload: {
            ...initialState.apiStatus,
            data: [],
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearQcSaveAPiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: QC_SAVE_MAPPING_STATUS,
      payload: { ...initialState.apiStatus },
    });
  };
};

export const getSheetsNames = (project_id) => {
  return (dispatch) => {
    service
      .getSheetsNames(project_id)
      .then((json) => {
        dispatch({
          type: GET_SHEETS_LIST,
          payload: json.data.data,
        });
      })
      .catch((error) => {});
  };
};

export const clearAutoRefresh = () => {
  return (dispatch) => {
    dispatch({
      type: AUTO_REFRESH,
      payload: { isAutoRefresh: false },
    });
  };
};

export const clearCloneProject = () => {
  return (dispatch) => {
    dispatch({
      type: CLONE_API_STATUS,
      payload: { ...initialState.apiStatus },
    });
  };
};

export const cloneProject = (projectName) => {
  return (dispatch) => {
    dispatch({
      type: CLONE_API_STATUS,
      payload: { ...initialState.apiStatus, loading: true },
    });
    service
      .clone(projectName)
      .then((response) => {
        dispatch({
          type: CLONE_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: response.data.message,
            loading: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: CLONE_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const setSelectedFileDataForProUpdateMapping = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE,
      payload: data,
    });
  };
};

export const clearResetProDataFromPre = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_PRO_DATA_FROM_PRE,
      payload: {},
    });
  };
};

export const bulkBatchCreation = (bulkBatchData) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: {
        ...initialState.apiStatus,
        message: "",
        loader: true,
        next: false,
      },
    });

    service
      .bulkBatchCreation(bulkBatchData)
      .then((json) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loading: false,
            next: true,
            message: json.data.message,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearOcrReinitiateApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: OCR_REINITIATE_STATUS,
      payload: {},
    });
  };
};

export const handleOcrReinitiate = (id) => {
  return (dispatch) => {
    dispatch({
      type: OCR_REINITIATE_STATUS,
      payload: {
        ...initialState.apiStatus,
        message: "",
        loader: true,
        next: false,
      },
    });

    service
      .handleOcrReinitiate(id)
      .then((res) => {
        dispatch({
          type: OCR_REINITIATE_STATUS,
          payload: {
            ...initialState.apiStatus,
            loading: false,
            next: true,
            message: res.data.data,
            apiSuccess: true,
          },
        });
        // dispatch({
        //   type: AUTO_REFRESH,
        //   payload: { isAutoRefresh: true },
        // });
      })
      .catch((error) => {
        dispatch({
          type: OCR_REINITIATE_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            apiError: true,
          },
        });
      });
  };
};

export const resetProDataFromPre = (projectId, projectType) => {
  return (dispatch) => {
    dispatch({
      type: RESET_PRO_DATA_FROM_PRE,
      payload: { ...initialState.apiStatus, loader: true },
    });

    service
      .resetProDataFromPre(projectId, projectType)
      .then((res) => {
        dispatch({
          type: RESET_PRO_DATA_FROM_PRE,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: true,
            message: res?.data?.message,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: RESET_PRO_DATA_FROM_PRE,
          payload: {
            ...initialState.apiStatus,
            apiError: true,
            message: errorMessage(error),
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getTagsUsersAndPdfs = (projectId, fileType, subFolder) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loading: true },
    });
    dispatch({
      type: GET_TAGS_USERS_PDFS,
      payload: {},
    });

    service
      .getTagsUsersAndPdfs(projectId, fileType, subFolder)
      .then((json) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: json.data.message,
            loading: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_TAGS_USERS_PDFS,
          payload: json?.data?.data,
        });

        // dispatch({
        //   type: GET_TAGS_USERS_PDFS,
        //   payload: {
        //     users: [
        //       "KripalPro",
        //       "PriyankaPro",
        //       "GaneshShindePro",
        //       "Progayatri",
        //       "QA",
        //       "NitinPro",
        //       "AnirudhhaPro",
        //       "PoojaPro",
        //       "DemoUser2",
        //       "GayatriPro",
        //       "SantoshPro",
        //       "AjayanPro",
        //       "SayaliPro",
        //     ],
        //     tags: ["Day1", "Day3", "Day9"],
        //     pdfs: [
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0001-A_BPR-0050.pdf",
        //         file_name: "121-22-0001-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
        //         file_name: "121-22-0010-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0012-A_BPR-0050.pdf",
        //         file_name: "121-22-0012-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
        //         file_name: "Z-05-9690-Day1_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day3_new_int.pdf",
        //         file_name: "Z-05-9690-Day3_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
        //         file_name: "Z-05-9690-Day9_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day1_newint.pdf",
        //         file_name: "Z-05-9699-Day1_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day3_newint.pdf",
        //         file_name: "Z-05-9699-Day3_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day9_newint.pdf",
        //         file_name: "Z-05-9699-Day9_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
        //         file_name: "name,tet,_sj1.pdf",
        //       },
        //     ],
        //   },
        // });
      })
      .catch((error) => {
        // setTimeout(() => {
        // dispatch({
        //   type: GET_TAGS_USERS_PDFS,
        //   payload: {
        //     users: [
        //       "KripalPro",
        //       "PriyankaPro",
        //       "GaneshShindePro",
        //       "Progayatri",
        //       "QA",
        //       "NitinPro",
        //       "AnirudhhaPro",
        //       "PoojaPro",
        //       "DemoUser2",
        //       "GayatriPro",
        //       "SantoshPro",
        //       "AjayanPro",
        //       "SayaliPro",
        //     ],
        //     tags: ["Day1", "Day3", "Day9"],
        //     pdfs: [
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0001-A_BPR-0050.pdf",
        //         file_name: "121-22-0001-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
        //         file_name: "121-22-0010-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0012-A_BPR-0050.pdf",
        //         file_name: "121-22-0012-A_BPR-0050.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
        //         file_name: "Z-05-9690-Day1_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day3_new_int.pdf",
        //         file_name: "Z-05-9690-Day3_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
        //         file_name: "Z-05-9690-Day9_new_int.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day1_newint.pdf",
        //         file_name: "Z-05-9699-Day1_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day3_newint.pdf",
        //         file_name: "Z-05-9699-Day3_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9699-Day9_newint.pdf",
        //         file_name: "Z-05-9699-Day9_newint.pdf",
        //       },
        //       {
        //         file_url:
        //           "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
        //         file_name: "name,tet,_sj1.pdf",
        //       },
        //     ],
        //   },
        // });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loading: false,
            apiError: true,
          },
        });
        // }, 6000);
      });
  };
};

export const createBatches = (batchesData, projectType) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loading: true },
    });
    service
      .createBatches(batchesData, projectType)
      .then((response) => {
        // localStorage.setItem(messages.BATCH_ID, response?.data?.data?.batch_id);
        // localStorage.setItem(
        //   messages.BATCH_NAME,
        //   response?.data?.data?.batch_name
        // );

        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loading: false,
            next: true,
            message: response.data.message,
            setSuccess: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loading: false,
            next: false,
            setError: true,
            apiError: true,
          },
        });
      });
  };
};

// export const getSavedBatchesData = (projectId) => {
//   return (dispatch) => {
//     dispatch({
//       type: API_STATUS,
//       payload: { ...initialState.apiStatus, loading: true },
//     });
//     service
//       .getSavedBatchesData(projectId)
//       .then((json) => {
//         dispatch({
//           type: SAVED_BATCHES_DATA,
//           payload: [
//             {
//               name: "B1",
//               files: [
//                 {
//                   tagName: "Day1",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                   pdfName: "Z-05-9690-Day9_new_int.pdf",
//                 },
//                 {
//                   tagName: "Day3",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
//                   pdfName: "121-22-0010-A_BPR-0050.pdf",
//                 },
//                 {
//                   tagName: "Day9",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                   pdfName: "Z-05-9690-Day9_new_int.pdf",
//                 },
//               ],
//               assignedUser: "PriyankaPro",
//               timelineDate: "2024-01-30T18:30:00.000Z",
//               autoExtraction: true,
//             },
//             // {
//             //   name: "B2",
//             //   files: [
//             //     {
//             //       tagName: "Day1",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day3",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day9",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//             //       pdfName: "name,tet,_sj1.pdf",
//             //     },
//             //   ],
//             //   assignedUser: "GaneshShindePro",
//             //   timelineDate: "2024-01-30T18:30:00.000Z",
//             // },
//             // {
//             //   name: "B3",
//             //   files: [
//             //     {
//             //       tagName: "Day1",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//             //       pdfName: "name,tet,_sj1.pdf",
//             //     },
//             //     {
//             //       tagName: "Day3",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day9",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//             //     },
//             //   ],
//             //   assignedUser: "GayatriPro",
//             //   timelineDate: "2024-01-31T18:30:00.000Z",
//             //   autoExtraction: true,
//             // },
//           ],
//         });
//         dispatch({
//           type: API_STATUS,
//           payload: {
//             ...initialState.apiStatus,
//             message: json.data.message,
//             loading: false,
//             next: false,
//             apiSuccess: true,
//           },
//         });
//       })
//       .catch((error) => {
//         setTimeout(() => {
//           dispatch({
//             type: SAVED_BATCHES_DATA,
//             payload: [
//               {
//                 name: "B2",
//                 files: [
//                   {
//                     tagName: "Day1",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//                     pdfName: "Z-05-9690-Day1_new_int.pdf",
//                   },
//                   {
//                     tagName: "Day3",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                     pdfName: "Z-05-9690-Day9_new_int.pdf",
//                   },
//                   {
//                     tagName: "Day9",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//                     pdfName: "name,tet,_sj1.pdf",
//                   },
//                 ],
//                 assignedUser: "GaneshShindePro",
//                 timelineDate: "2024-01-30T18:30:00.000Z",
//               },
//               // {
//               //   name: "B1",
//               //   files: [
//               //     {
//               //       tagName: "Day1",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //     {
//               //       tagName: "Day3",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
//               //       pdfName: "121-22-0010-A_BPR-0050.pdf",
//               //     },
//               //     {
//               //       tagName: "Day9",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //   ],
//               //   assignedUser: "PriyankaPro",
//               //   timelineDate: "2024-01-30T18:30:00.000Z",
//               //   autoExtraction: true,
//               // },
//               // {
//               //   name: "B3",
//               //   files: [
//               //     {
//               //       tagName: "Day1",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//               //       pdfName: "name,tet,_sj1.pdf",
//               //     },
//               //     {
//               //       tagName: "Day3",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //     {
//               //       tagName: "Day9",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//               //     },
//               //   ],
//               //   assignedUser: "GayatriPro",
//               //   timelineDate: "2024-01-31T18:30:00.000Z",
//               //   autoExtraction: true,
//               // },
//             ],
//           });
//           dispatch({
//             type: API_STATUS,
//             payload: {
//               ...initialState.apiStatus,
//               message: errorMessage(error),
//               loading: false,
//               apiError: true,
//             },
//           });
//         }, 6000);
//       });
//   };
// };

// export const getSavedBatchesData = (projectId) => {
//   return (dispatch) => {
//     dispatch({
//       type: API_STATUS,
//       payload: { ...initialState.apiStatus, loading: true },
//     });
//     service
//       .getSavedBatchesData(projectId)
//       .then((json) => {
//         dispatch({
//           type: SAVED_BATCHES_DATA,
//           payload: [
//             {
//               name: "B1",
//               files: [
//                 {
//                   tagName: "Day1",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                   pdfName: "Z-05-9690-Day9_new_int.pdf",
//                 },
//                 {
//                   tagName: "Day3",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
//                   pdfName: "121-22-0010-A_BPR-0050.pdf",
//                 },
//                 {
//                   tagName: "Day9",
//                   pdfPath:
//                     "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                   pdfName: "Z-05-9690-Day9_new_int.pdf",
//                 },
//               ],
//               assignedUser: "PriyankaPro",
//               timelineDate: "2024-01-30T18:30:00.000Z",
//               autoExtraction: true,
//             },
//             // {
//             //   name: "B2",
//             //   files: [
//             //     {
//             //       tagName: "Day1",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day3",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day9",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//             //       pdfName: "name,tet,_sj1.pdf",
//             //     },
//             //   ],
//             //   assignedUser: "GaneshShindePro",
//             //   timelineDate: "2024-01-30T18:30:00.000Z",
//             // },
//             // {
//             //   name: "B3",
//             //   files: [
//             //     {
//             //       tagName: "Day1",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//             //       pdfName: "name,tet,_sj1.pdf",
//             //     },
//             //     {
//             //       tagName: "Day3",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//             //     },
//             //     {
//             //       tagName: "Day9",
//             //       pdfPath:
//             //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//             //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//             //     },
//             //   ],
//             //   assignedUser: "GayatriPro",
//             //   timelineDate: "2024-01-31T18:30:00.000Z",
//             //   autoExtraction: true,
//             // },
//           ],
//         });
//         dispatch({
//           type: API_STATUS,
//           payload: {
//             ...initialState.apiStatus,
//             message: json.data.message,
//             loading: false,
//             next: false,
//             apiSuccess: true,
//           },
//         });
//       })
//       .catch((error) => {
//         setTimeout(() => {
//           dispatch({
//             type: SAVED_BATCHES_DATA,
//             payload: [
//               {
//                 name: "B2",
//                 files: [
//                   {
//                     tagName: "Day1",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//                     pdfName: "Z-05-9690-Day1_new_int.pdf",
//                   },
//                   {
//                     tagName: "Day3",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//                     pdfName: "Z-05-9690-Day9_new_int.pdf",
//                   },
//                   {
//                     tagName: "Day9",
//                     pdfPath:
//                       "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//                     pdfName: "name,tet,_sj1.pdf",
//                   },
//                 ],
//                 assignedUser: "GaneshShindePro",
//                 timelineDate: "2024-01-30T18:30:00.000Z",
//               },
//               // {
//               //   name: "B1",
//               //   files: [
//               //     {
//               //       tagName: "Day1",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //     {
//               //       tagName: "Day3",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/121-22-0010-A_BPR-0050.pdf",
//               //       pdfName: "121-22-0010-A_BPR-0050.pdf",
//               //     },
//               //     {
//               //       tagName: "Day9",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //   ],
//               //   assignedUser: "PriyankaPro",
//               //   timelineDate: "2024-01-30T18:30:00.000Z",
//               //   autoExtraction: true,
//               // },
//               // {
//               //   name: "B3",
//               //   files: [
//               //     {
//               //       tagName: "Day1",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/name,tet,_sj1.pdf",
//               //       pdfName: "name,tet,_sj1.pdf",
//               //     },
//               //     {
//               //       tagName: "Day3",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day9_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day9_new_int.pdf",
//               //     },
//               //     {
//               //       tagName: "Day9",
//               //       pdfPath:
//               //         "https://cpv.dev.s3.amazonaws.com/Development/rawFiles/pdfs/new_int/Z-05-9690-Day1_new_int.pdf",
//               //       pdfName: "Z-05-9690-Day1_new_int.pdf",
//               //     },
//               //   ],
//               //   assignedUser: "GayatriPro",
//               //   timelineDate: "2024-01-31T18:30:00.000Z",
//               //   autoExtraction: true,
//               // },
//             ],
//           });
//           dispatch({
//             type: API_STATUS,
//             payload: {
//               ...initialState.apiStatus,
//               message: errorMessage(error),
//               loading: false,
//               apiError: true,
//             },
//           });
//         }, 6000);
//       });
//   };
// };

export const updateQcParametersData = (data) => {
  return (dispatch) => {
    dispatch({
      type: QC_PARAMETERS_DATA,
      payload: data,
    });
  };
};

export const getUploadedFilesList = (data) => {
  return (dispatch) => {
    dispatch({
      type: LIST_UPLOADED_FILES_RECORD,
      payload: { ...initialState?.apiStatus, loading: true, data: [] },
    });
    // dispatch({
    //   type: LIST_UPLOADED_FILES_RECORD,
    //   payload: [],
    // });
    service
      .getUploadedFilesList(data)
      .then((res) => {
        // dispatch({
        //   type: LIST_UPLOADED_FILES_RECORD,
        //   payload: res.data,
        // });
        dispatch({
          type: LIST_UPLOADED_FILES_RECORD,
          payload: {
            ...initialState?.apiStatus,
            loading: false,
            data: res.data,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: LIST_UPLOADED_FILES_RECORD,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loading: false,
            next: false,
            apiError: true,
            data: [],
          },
        });
      });
  };
};

export const getFileForPreview = (filePath) => {
  return (dispatch) => {
    dispatch({
      type: UPLOADING_IP_OP_FILE_PREVIEW,
      payload: [],
    });
    dispatch({
      type: API_STATUS,
      payload: { ...initialState.apiStatus, loader: true },
    });
    service
      .getFileForPreview(filePath)
      .then((response) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: UPLOADING_IP_OP_FILE_PREVIEW,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            isError: true,
            apiError: true,
          },
        });
      });
  };
};

export const clearFileForPreview = (data) => {
  return (dispatch) => {
    dispatch({
      type: UPLOADING_IP_OP_FILE_PREVIEW,
      payload: [],
    });
  };
};

export const getInvestigatorUserList = () => {
  return (dispatch) => {
    dispatch({
      type: GET_INVESTIGATOR_USER_LIST,
      payload: { data: [], loader: true, message: "" },
    });
    service
      .getInvestigatorUserList()
      .then((json) => {
        dispatch({
          type: GET_INVESTIGATOR_USER_LIST,
          payload: { data: json.data.data, loader: false, message: "" },
        });
      })

      .catch((error) => {
        dispatch({
          type: GET_INVESTIGATOR_USER_LIST,
          payload: { data: [], message: errorMessage(error), loader: false },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            data: [],
            message: errorMessage(error),
            loader: false,
            setError: true,
            apiError: true,
          },
        });
      });
  };
};


export const setBboxFromDrawFromPre = (
  // value,
  coords,
) => {
  return (dispatch) => {
    dispatch({
      type: SET_BBOX_FROM_DRAW_FROM_PRE,
      payload: coords,
    });
  };
};

export const heighlightBBoxInPre = (coords) => {
  return (dispatch) => {
    dispatch({
      type: HIGHLIGHT_BBOX_IN_PRE,
      payload: coords,
    });
  };
}